import { useEffect } from "react";
import { useAppSelector } from "./useAppSelector"
import { useAppDispatch } from "./useAppDispatch";
import { fetchBasket, resetBasket } from "../store/features/ordering/basket/basket-slice";

export const useBasket = () => {
    const basket = useAppSelector((state => state.basket));
    const branch = useAppSelector((state => state.branch)).selectedBranch;
    const dispatch = useAppDispatch();

    // When the branch changes, clear the stale basket so the next effect re-fetches.
    useEffect(() => {
        dispatch(resetBasket());
    }, [branch?.id]);

    useEffect(() => {
        if (basket.basket == null && branch) {
            dispatch(fetchBasket(branch.id));
        }
    }, [basket.basket, branch?.id]);

    return basket.basket;
}